import PropTypes from 'prop-types'
import { CheckCircle } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { APP_COLORS } from '../../helpers/constants'

const AccessCode = ({ onDone, accessCode }) => {
  const { t } = useTranslation(['package-room'])
  return (
    <div className="package-room__content package-room__content--full">
      <div className="package-room__access-container">
        <div className="package-room__icon">
          <CheckCircle size={60} color={APP_COLORS.grayDarkest} weight="regular" />
        </div>

        <h2 className="package-room__title package-room__title--gray">
          {t('package-room:accessCode.title')}
        </h2>
        <p className="package-room__subtitle">{t('package-room:accessCode.subtitle')}</p>

        <div className="package-room__code-container">
          <p className="package-room__code-instruction">
            {t('package-room:accessCode.codeInstruction')}
          </p>

          <div className="package-room__code">
            {accessCode.split('').map((digit, index) => (
              <span key={index} className="package-room__digit">
                {digit}
              </span>
            ))}
          </div>

          <div className="package-room__keypad">
            <img
              src="/images/package-room/keypad.png"
              alt={t('package-room:accessCode.keypadAlt')}
              className="package-room__keypad-image"
            />
          </div>
        </div>
      </div>

      <div className="package-room__action-buttons">
        <button className="package-room__submit-button" onClick={onDone}>
          {t('package-room:accessCode.resetAndStartNew')}
        </button>
      </div>
    </div>
  )
}

AccessCode.propTypes = {
  onDone: PropTypes.func.isRequired,
  accessCode: PropTypes.string.isRequired,
}

export default AccessCode
